import { useEffect, useState } from "react";
import { Button } from "@similarweb/ui-components";
import { Textfield } from "@similarweb/ui-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import {
    StyledModalBody,
    StyledModalContent,
    StyledModalFooter,
    StyledModalTitle,
} from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/components/SavedSearchDeleteModal/styles";
import { CUSTOM_MODAL_STYLES, StyledLabel, StyledNameInputContainer } from "./styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

export type ListRenameModalProps = {
    isOpen: boolean;
    currentName: string;
    isBeingSubmitted: boolean;
    onCancel(): void;
    onSubmit(name: string): void;
};

const ListRenameModal = (props: ListRenameModalProps) => {
    const { isOpen, currentName, isBeingSubmitted, onCancel, onSubmit } = props;
    const [name, setName] = useState("");
    const isNameValid = name.trim().length > 3;

    useEffect(() => {
        setName(currentName);
    }, [currentName]);

    useEffect(() => {
        if (isOpen) {
            setName(currentName);
        } else {
            setName("");
        }
    }, [isOpen]);

    function handleSubmitClick() {
        if (isNameValid) {
            onSubmit(name.trim());
        }
    }

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={CUSTOM_MODAL_STYLES}
        >
            <StyledModalContent data-automation="rename-list-modal">
                <StyledModalBody>
                    <I18n
                        element={StyledModalTitle}
                        data-automation="title-text"
                        translatable={{ key: "si.static-lists.rename-modal.title" }}
                    />
                    <StyledNameInputContainer>
                        <I18n
                            element={StyledLabel}
                            data-automation="label-text"
                            translatable={{ key: "si.static-lists.rename-modal.input-label" }}
                        />
                        <Textfield
                            autoFocus
                            maxLength={200}
                            defaultValue={currentName}
                            dataAutomation="name-input"
                            onChange={setName}
                        />
                    </StyledNameInputContainer>
                </StyledModalBody>
                <StyledModalFooter>
                    <Button
                        type="flat"
                        onClick={onCancel}
                    >
                        {translate("si.common.button.cancel")}
                    </Button>
                    <Button
                        type="primary"
                        isLoading={isBeingSubmitted}
                        isDisabled={!isNameValid || isBeingSubmitted}
                        onClick={handleSubmitClick}
                    >
                        {translate("si.common.button.rename")}
                    </Button>
                </StyledModalFooter>
            </StyledModalContent>
        </ProModal>
    );
}

export default ListRenameModal;
